import { CodeMaintenanceType } from 'src/constants/nacodemaintenance'
import PropTypes from 'prop-types'
import naCodeMaintenanceAutocompleteField from './NaCodeDescCodeMaintainceAutoCompleteField'

function NaAirPortAutocompleteField(props) {
  return naCodeMaintenanceAutocompleteField(
    props,
    CodeMaintenanceType.AIRPORT
  )
}

export default NaAirPortAutocompleteField